import React from 'react';
import {connect} from 'dva';
import {Spin, Tabs} from 'antd';
import {injectIntl} from 'react-intl';
import {getUrlParam} from '../utils/common';
import ReservationDialog from '../components/commons/ReservationDialog';
import {TriangleWrap} from '../components/Widgets';
import MeetingDetail from '../components/meeting/MeetingDetail';
import MeetingService from '../components/meetingList/MeetingService';
import MeetingSign from '../components/meetingList/MeetingSign';
import MeetingAgenda from '../components/meetingList/MeetingAgenda';
import MeetingDevice from '../components/meetingList/MeetingDevice';
import MeetingVideo from '../components/meetingList/MeetingVideo';
import {checkOperateAuth} from '../utils/meetingUtil';
import {
  MEETING_AUDIT,
  MEETING_STATUS,
  ROOM_ALLOW_SVC
} from '../utils/constants';
import PromptInfo from '../utils/promptInfo';

class MeetingInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {loading: false};
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    // window.clearInterval(this.interval);
  }

  render() {
    const {meetingInfo, dispatch, intl, userInfo, loading} = this.props;
    const {
      currentTab = 1,
      meetingAgenda = [],
      meetingSign = [],
      svcData,
      meetingSvcData,
      meetingVideoData,
      mainTainList,
      showLiveOrVideoTab,
      meetingDevice,
      meeting
    } = meetingInfo;
    let {allDevice, allDeviceIncludeDel} = meetingInfo;
    let allDeviceForMeeting = [];

    let {
      showAgendaTab,
      showSignTab,
      showSvcTab,
      showDeviceTab,
    } = this.checkTabsStatus();

    const meetingId = getUrlParam('meetingId');
    if (meetingId && meetingId > 0) {
      //对allDevice过滤，筛选出当前会议的会议室所在的区域
      if (meeting) {
        let rooms = meeting.rooms;
        let zoneIds = [];
        if (rooms && rooms.length > 0) {
          rooms.map(r => {
            zoneIds.push(r.zoneId);
          });
        }
        allDeviceForMeeting = allDevice.filter(item => {
          return zoneIds.some(zid => zid == item.zoneId);
        });
      }
    }

    let isCreator = false;
    if (meetingId && meetingId > 0 && Object.keys(meeting).length > 0) {
      if (!checkOperateAuth(meeting, userInfo)) {
        //参会人
        isCreator = false;
      } else {
        //申请人、创建者或者会议室管理员
        isCreator = true;
      }
    }

    const {
      isOpenSign,
      isOpenSvc,
      isOpenAgenda,
      isOpenDevice
    } = this.checkTabsOpen();

    let tabs = [
      {
        name: intl.formatMessage({id: 'meeting_tab_meeting_info'}),
        index: '1',
        clickAble: true,
        show: true
      }
    ];
    if (isOpenSvc) {
      tabs.push({
        name: intl.formatMessage({id: 'meeting_tab_meeting_service_apply'}),
        index: '2',
        clickAble: showSvcTab,
        show: isCreator
      });
    }
    if (isOpenSign) {
      tabs.push({
        name: intl.formatMessage({id: 'meeting_tab_meeting_sign'}),
        index: '3',
        clickAble: showSignTab,
        show: isCreator
      });
    }
    if (isOpenAgenda) {
      tabs.push({
        name: intl.formatMessage({id: 'meeting_tab_meeting_agenda'}),
        index: '4',
        clickAble: showAgendaTab,
        show: true
      });
    }
    if (isOpenDevice) {
      tabs.push({
        name: intl.formatMessage({id: 'meeting_tab_meeting_device_lend'}),
        index: '5',
        clickAble: showDeviceTab,
        show: isCreator
      });
    }

    if (meetingId && meetingId) {
      tabs = tabs.filter(t => t.show);
    }

    const viewOnly = this.checkViewOnly();
    return (
      <div className="meeting_info">
        {false && <div className="header">
          {tabs &&
          tabs.map((tab, index) => {
            let className = 'tab_span';
            if (tab.index == meetingInfo.currentTab) {
              className = 'tab_span tab_select';
            }
            if (!tab.clickAble) {
              className = 'tab_span tab_disabled';
            }
            let clickHandle = () => {
              if (!tab.clickAble) {
                return false;
              }
              if (tab.index == '1' || meetingInfo.meetingId > 0) {
                dispatch({
                  type: 'meetingInfo/set',
                  payload: {currentTab: tab.index}
                });
              } else {
                ReservationDialog({
                  type: PromptInfo.DialogType.INFORMATION,
                  message: '请先保存会议'
                });
              }
            };

            return (
              <div key={'tab-' + index}>
                  <span className={className} onClick={clickHandle}>
                    {tab.name}
                  </span>
                {index != tabs.length - 1 && <div className="separate"/>}
              </div>
            );
          })}
        </div>}
        <TriangleWrap className="main_content">
          <Spin spinning={loading} size="large">
            <div className="header-div">
              <Tabs size="large" activeKey={`tab-${meetingInfo.currentTab}`} onTabClick={x => {
                let index = x.split('-')[1];
                if (index == '1' || meetingInfo.meetingId > 0) {
                  dispatch({
                    type: 'meetingInfo/set',
                    payload: {currentTab: index}
                  });
                }
              }}>
                {
                  tabs.map(item => {
                    return <Tabs.TabPane disabled={!item.clickAble} tab={item.name} key={`tab-${item.index}`}/>;
                  })
                }
              </Tabs>
            </div>
            {currentTab == 1 && (
              <MeetingDetail
                intl={intl}
                dispatch={dispatch}
                viewOnly={viewOnly}
              />
            )}
            {currentTab == 2 && (
              <MeetingService
                intl={intl}
                dispatch={dispatch}
                meeting={meeting}
                svcData={svcData}
                meetingSvcData={meetingSvcData}
                viewOnly={viewOnly}
                userInfo={userInfo}
                meetingPolicy={this.props.meetingPolicy || {}}
              />
            )}
            {currentTab == 3 && (
              <MeetingSign
                intl={intl}
                dispatch={dispatch}
                meetingSign={meetingSign}
                meeting={meeting}
                viewOnly={viewOnly}
              />
            )}
            {currentTab == 4 && (
              <MeetingAgenda
                intl={intl}
                dispatch={dispatch}
                viewOnly={viewOnly}
                meetingAgenda={meetingAgenda}
                meeting={meeting}
              />
            )}
            {currentTab == 5 && (
              <MeetingDevice
                intl={intl}
                dispatch={dispatch}
                meetingDevice={meetingDevice}
                allDeviceForMeeting={allDeviceForMeeting}
                allDevice={allDevice}
                meeting={meeting}
                viewOnly={viewOnly}
                allDeviceIncludeDel={allDeviceIncludeDel}
              />
            )}
            {currentTab == 6 && (
              <MeetingVideo
                intl={intl}
                dispatch={dispatch}
                meetingId={meetingId}
                meeting={meeting}
                showLiveOrVideoTab={showLiveOrVideoTab}
                isCreator={isCreator}
                meetingVideoData={meetingVideoData}
                mainTainList={mainTainList}
                viewOnly={viewOnly}
              />
            )}
          </Spin>
        </TriangleWrap>
      </div>
    );
  }

  /**
   * 检查当前的会议页面是否不可编辑
   * @return boolean  true: 不可编辑，false: 可编辑
   * */
  checkViewOnly = () => {
    const {meetingInfo, userInfo} = this.props;
    const {meeting = {}} = meetingInfo;
    const meetingId = getUrlParam('meetingId');
    const operateType = getUrlParam('operateType');
    if ('1' === operateType && meetingId) {
      //预约首页右键查看会议
      return true;
    }
    if (meetingId) {
      //编辑会议
      const {status} = meeting;
      if (!checkOperateAuth(meeting, userInfo)) {
        return true;
      }
      return !(
        status === MEETING_STATUS.pending ||
        status === MEETING_STATUS.audit ||
        status === MEETING_STATUS.reject
      );
    } else {
      //预约或再次预约
      return false;
    }
  };

  checkTabsStatus = () => {
    const {meetingInfo, userInfo} = this.props;
    const {
      meetingAgenda = [],
      meetingSvcData,
      meetingDevice,
      meeting
    } = meetingInfo;
    let showAgendaTab = false,
      showSignTab = false,
      showSvcTab = false,
      showDeviceTab = false,
      showVideoTab = false;

    const meetingId = getUrlParam('meetingId');
    if (meetingId && meetingId > 0) {
      const {audit, status} = meeting;
      if (!checkOperateAuth(meeting, userInfo)) {
        //参会人
        showAgendaTab = meetingAgenda && meetingAgenda.length > 0;
        // showSignTab = meetingSign && meetingSign.length > 0;
        showSvcTab =
          meetingSvcData &&
          meetingSvcData.svcs &&
          meetingSvcData.svcs.length > 0;
        showDeviceTab = meetingDevice && meetingDevice.length > 0;
      } else {
        showAgendaTab = true;
        // showSignTab = true;
        showSvcTab = true;
        showDeviceTab = true;
      }

      if (meeting.openVideo === 0) {
        showVideoTab = true;
      }
      //签到tab
      //有需要签到的会议室时才显示签到页
      if (
        meeting &&
        meeting.rooms &&
        meeting.rooms.some(mr => mr.sign != -1) &&
        meeting.needToSign === 0
      ) {
        showSignTab = true;
      }
      if (
        meeting &&
        meeting.rooms &&
        meeting.rooms.some(mr => mr.allowSvc === ROOM_ALLOW_SVC.no)
      ) {
        //会议室不允许申请会议服务
        showSvcTab = false;
      }
      if (
        audit === MEETING_AUDIT.yes &&
        (status === MEETING_STATUS.audit || status === MEETING_STATUS.reject)
      ) {
        //需要审批的会议，只能是审批通过后才能进行会议服务申请、会议设备申请等操作
        showAgendaTab = false;
        showSignTab = false;
        showSvcTab = false;
        showDeviceTab = false;
        showVideoTab = false;
      }
    }
    return {
      showAgendaTab,
      showSignTab,
      showSvcTab,
      showDeviceTab,
      showVideoTab
    };
  };

  checkTabsOpen = () => {
    const {
      showMeetingSign = false,
      showMeetingSvc = false,
      showMeetingAgenda = false,
      showMeetingDevice = false
    } = this.props.meetingPolicy;
    return {
      isOpenSign: showMeetingSign,
      isOpenSvc: showMeetingSvc,
      isOpenAgenda: showMeetingAgenda,
      isOpenDevice: showMeetingDevice
    };
  };
}

export default connect(state => ({
  meetingInfo: state.meetingInfo,
  userInfo: state.login.userInfo || {},
  loading: state.loading.global,
  allRoomList: state.meeting.allRoomList,
  meetingPolicy: state.account.meetingPolicy || {}
}))(injectIntl(MeetingInfo));



// WEBPACK FOOTER //
// ./src/routes/MeetingInfo.js